import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";
import { CreateDealActionResult } from "../../../actions/create-deal.action.ts";

export const createDealReducer = (
  state: LoanState,
  action: PayloadAction<CreateDealActionResult>,
) => {
  const { dealId, loanIntent } = action.payload;
  state.dealId = dealId!;
  state.loanIntent = loanIntent!;
};
